export default "__VITE_PUBLIC_ASSET__00c24e35__"